//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import autocomplete from '~/mixins/components/autocomplete';

export default {
  name: 'autocomplete-commodity-used',
  mixins: [autocomplete],
  props: {
    expeditor: {
      type: [String, Number],
      default: '',
    },
  },
  data () {
    return {
      updateKey: 1,
      searchKeys: [
        {
          name: 'name',
          weight: 1,
        },
      ],
    };
  },
  computed: {
    params () {
      return { expeditor: this.expeditor };
    },
  },
  watch: {
    expeditor: {
      handler () {
        this.updateKey++;
      },
    },
  },
};
